import { Adapter as m } from "../../../adapter.js";
import { UsageRuleModel as s } from "./usageRule.model.js";
class t extends m {
  adapt(e) {
    return new s({
      ruleType: e.rule_type,
      locations: e.locations,
      timeframe: e.timeframe,
      timeframeSeconds: e.timeframe_seconds,
      maximumUses: e.maximum_uses,
      unit: e.unit,
      weekDays: e.week_days,
      startTime: e.start_time,
      endTime: e.end_time,
      fullDay: e.full_day
    });
  }
  serialize(e) {
  }
}
export {
  t as UsageRuleAdapter
};
//# sourceMappingURL=usageRule.adapter.js.map
